import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-application-users',
  templateUrl: './application-users.component.html',
  styleUrls: ['./application-users.component.css'],
})
export class ApplicationUsersComponent extends BaseListCtl {
  @Input() curApp: any;
  currentRoleData: any;
  permission: any;
  public datavalidate = true;
  public users: any = [];
  public applicationRoles: any = [];
  public appId: any;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super(locator.config.get('endpoint.application.users'), locator, route);

    let _self = this;
    if (route.snapshot.paramMap.get('id')) {
      _self.appId = Number(route.snapshot.paramMap.get('id'));
      _self.form.searchParams['applicationId'] = _self.appId;
    }
  }

  /**
   * On init
   */
  override ngOnInit() {
    this.resetForm();
    this.form.searchParams['applicationId'] = this.appId;
    this.search();
    this.getUsers();
    this.getApplicationRoles();
    this.CurrentRoleData();
  }

  /**
   * On changes
   */
  ngOnChanges() {
    this.resetForm();
    this.form.searchParams['applicationId'] = this.appId;
    this.search();
    this.getUsers();
    this.getApplicationRoles();
  }

  public applicationName: any = '';
  /**
   * Reset form
   */
  override search(): void {
    this.form.searchParams = { applicationId: Number(this.appId) };
    super.search((error: any) => {
      if (this.form.searchMessage === 'Record not found') {
        this.form.list = [];
      } else if (this.form.list && this.form.list.length > 0) {
        const firstItem = this.form.list[0];
        if (firstItem && firstItem['applicationName']) {
          this.applicationName = firstItem['applicationName'];
        }
      }
    });
  }

  /**
   * Check if null or blank
   * @param value
   * @returns
   */
  // isNullOrBlank(value: any) {
  //   return value === null || value.trim() === '';
  // }
  isNullOrBlank(value: unknown): boolean {
    if (value === null || value === undefined) return true;

    if (typeof value === 'string') {
      return value.trim().length === 0;
    }

    return false;
  }

  /**
   * Save form
   */
  // override async save() {
  //   const _self = this;

  //   if (this.emailList.length === 0) {
  //     if (this.emailInput && this.emailInput.trim() !== '') {
  //       this.emailList.push(this.emailInput.trim());
  //       _self.form.data['email'] = this.emailList.join(', ');
  //     } else {
  //       // Dono empty hain to error dikhado
  //       alert('Please enter at least one email address');
  //       return;
  //     }
  //   } else {
  //     // Email list already filled hai
  //     _self.form.data['email'] = this.emailList.join(', ');
  //   }
  //   // Show confirmation dialog
  //   const confirmCreate = confirm(
  //     'Are you sure you want to send an invitation for this role?',
  //   );

  //   if (!confirmCreate) {
  //     return; // Stop if user cancels
  //   }

  //   // Set application ID and status
  //   _self.form.data['applicationId'] = this.appId;
  //   _self.form.data['status'] = 'Pending';

  //   // Check for duplicates and invalid emails
  //   await _self.checkDuplicate(
  //     _self.form.data['email'],
  //     _self.form.data['applicationRoleId'],
  //   );

  //   // Extract remaining valid emails
  //   const filteredEmails = _self.form.data['email']
  //     ?.split(',')
  //     .map((e: string) => e.trim())
  //     .filter((e: string) => e.length > 0);

  //   if (_self.datavalidate && filteredEmails.length > 0) {
  //     // Additional basic checks
  //     if (_self.isNullOrBlank(_self.form.data['email'])) {
  //       _self.form.inputerror['email'] = 'Email required';
  //       return;
  //     }

  //     if (_self.isNullOrBlank(_self.form.data['applicationRoleId'])) {
  //       _self.form.inputerror['applicationRoleId'] = 'Role required';
  //       return;
  //     }
  //     super.save();
  //     this.search();
  //   } else {
  //     if (!_self.form.inputerror) {
  //       _self.form.inputerror = {};
  //     }
  //     let existingError = _self.form.inputerror?.['email'] || '';
  //     if (_self.form.message?.length > 0) {
  //       existingError += '\n' + _self.form.message;
  //     }
  //     _self.form.inputerror['email'] = existingError;
  //     _self.form.error = true;
  //     _self.form.message = existingError;
  //     console.warn('Save aborted: No valid email found.');
  //   }

  //   // this.resetForm();

  //   setTimeout(() => {
  //     this.resetselectemails();
  //   }, 3500);
  // }
  override async save() {
    console.log('[SAVE] Triggered');

    const _self = this;

    console.log('[STATE] Initial emailList:', this.emailList);
    console.log('[STATE] emailInput:', this.emailInput);

    if (this.emailList.length === 0) {
      console.log('[FLOW] emailList is empty');

      if (this.emailInput && this.emailInput.trim() !== '') {
        const trimmedEmail = this.emailInput.trim();
        console.log('[ACTION] Adding emailInput to list:', trimmedEmail);

        this.emailList.push(trimmedEmail);
        _self.form.data['email'] = this.emailList.join(', ');

        console.log('[STATE] Updated emailList:', this.emailList);
        console.log('[STATE] Form email:', _self.form.data['email']);
      } else {
        console.warn('[VALIDATION] No email provided');
        alert('Please enter at least one email address');
        return;
      }
    } else {
      console.log('[FLOW] Using existing emailList');
      _self.form.data['email'] = this.emailList.join(', ');
      console.log('[STATE] Form email:', _self.form.data['email']);
    }

    // Confirmation
    console.log('[ACTION] Asking for confirmation');
    const confirmCreate = confirm(
      'Are you sure you want to send an invitation for this role?',
    );

    console.log('[USER ACTION] Confirm result:', confirmCreate);

    if (!confirmCreate) {
      console.warn('[FLOW] User cancelled operation');
      return;
    }

    // Set metadata
    _self.form.data['applicationId'] = this.appId;
    _self.form.data['status'] = 'Pending';

    console.log('[STATE] Application ID:', this.appId);
    console.log('[STATE] Status set to Pending');

    // Duplicate check
    console.log('[ACTION] Checking duplicates...');
    await _self.checkDuplicate(
      _self.form.data['email'],
      _self.form.data['applicationRoleId'],
    );
    console.log('[RESULT] Duplicate check complete');
    console.log('[STATE] datavalidate:', _self.datavalidate);
    console.log('[STATE] form.message:', _self.form.message);

    // Extract emails
    const filteredEmails = _self.form.data['email']
      ?.split(',')
      .map((e: string) => e.trim())
      .filter((e: string) => e.length > 0);

    console.log('[STATE] Filtered emails:', filteredEmails);

    if (_self.datavalidate && filteredEmails.length > 0) {
      console.log('[FLOW] Validation passed');

      if (_self.isNullOrBlank(_self.form.data['email'])) {
        console.warn('[VALIDATION] Email is blank');
        _self.form.inputerror['email'] = 'Email required';
        return;
      }

      if (_self.isNullOrBlank(_self.form.data['applicationRoleId'])) {
        console.warn('[VALIDATION] Role is missing');
        _self.form.inputerror['applicationRoleId'] = 'Role required';
        return;
      }

      console.log('[ACTION] Calling super.save()');
      super.save();

      console.log('[ACTION] Refreshing search');
      this.search();
    } else {
      console.error('[FLOW] Validation failed');

      if (!_self.form.inputerror) {
        _self.form.inputerror = {};
      }

      let existingError = _self.form.inputerror?.['email'] || '';

      if (_self.form.message?.length > 0) {
        existingError += '\n' + _self.form.message;
      }

      _self.form.inputerror['email'] = existingError;
      _self.form.error = true;
      _self.form.message = existingError;

      console.error('[ERROR] Final error message:', existingError);
    }

    // Reset emails after delay
    console.log('[ACTION] Scheduling email reset');

    setTimeout(() => {
      console.log('[ACTION] Resetting selected emails');
      this.resetselectemails();
    }, 3500);
  }

  /**
   * Get usecase attributes
   * @param id
   */
  getApplicationRoles() {
    let _self = this;
    let url = _self.endpoint + '/application-roles/' + this.appId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationRoles = res.result.data;
    });
  }

  /**
   * Get users
   */
  getUsers() {
    let _self = this;
    // get users
    let url = this.locator.getEndpoint('endpoint.user') + '/search/0';
    this.locator.http.post(url, {}, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        _self.users = [];
        return;
      }
      _self.users = res.result.data;
    });
  }

  /**
   * Check Duplicate
   * @param email
   * @param roleId
   * @returns
   */

  public async checkDuplicate(emails: string, roleId: any) {
    let _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.datavalidate = true;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Split and trim each email
    const emailArray = emails
      .split(',')
      .map((e) => e.trim())
      .filter((e) => e);

    for (let email of emailArray) {
      // Check email format
      if (!emailPattern.test(email)) {
        _self.form.error = true;
        _self.datavalidate = false;
        _self.form.inputerror['email'] = `Invalid email: ${email}`;
        return; // stop if invalid
      }

      // Check roleId
      if (!roleId || roleId === 'undefined') {
        _self.datavalidate = false;
        console.error('datavalidate is false: roleId is missing or invalid');
        return;
      }

      // Check duplicates
      let user = _self.form.list.find(
        (user: { email: any; applicationRoleId: any }) =>
          user.email === email && user.applicationRoleId == roleId,
      );

      if (user) {
        _self.datavalidate = false;
        _self.form.error = true;
        _self.form.message = `Duplicate role mapping for: ${email}`;
        return; // stop if duplicate found
      }
    }

    // If all good
    _self.datavalidate = true;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.inputerror['email'] = '';
  }

  public emailInput: string = '';
  public emailList: string[] = [];
  public emailError: string = '';

  public addEmail(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    const email = this.emailInput.trim();

    if (!email) return;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      this.emailError = `Invalid email: ${email}`;
    } else if (this.emailList.includes(email)) {
      this.emailError = `Duplicate email: ${email}`;
    } else {
      this.emailList.push(email);
      this.emailError = '';
      this.emailInput = '';
    }
  }
  public clearEmailError() {
    let _self = this;
    this.emailError = '';
    _self.datavalidate = true;
    _self.form.error = false;
    _self.form.message = '';
     if (!_self.form.inputerror) {
        _self.form.inputerror = {};
    }
    _self.form.inputerror['email'] = '';
  }
  public removeEmail(index: number) {
    this.emailList.splice(index, 1);
  }

  /**
   * Change app status
   * @param id
   * @param status
   */
  public changeStatus(id: number, status: string) {
    let _self = this;
    let url =
      this.locator.getEndpoint('endpoint.application.users') +
      '/changestatus/' +
      id +
      '/' +
      status;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        alert('Status is changed to ' + status);
        _self.form.list.forEach((e: any) => {
          if (e.id === id) {
            e.status = res.result.data.status;
          }
        });
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  public onStatusChange(
    event: Event,
    e: any,
    selectEl: HTMLSelectElement,
  ): void {
    const originalStatus = e.status;

    const target = event.target as HTMLSelectElement;
    const newStatus = target.value;

    const confirmed = confirm(
      `Are you sure you want to change the status to "${newStatus}"?`,
    );

    if (!confirmed) {
      // Revert visual dropdown selection
      setTimeout(() => {
        selectEl.value = originalStatus;
      });
      return;
    }

    const url = `${this.locator.getEndpoint(
      'endpoint.application.users',
    )}/changestatus/${e.id}/${newStatus}`;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        setTimeout(() => {
          selectEl.value = originalStatus;
        });
        return;
      }

      this.form.error = !res.success;
      this.form.message = res.message;

      if (res.success) {
        // alert('Status successfully changed to ' + newStatus);
        e.status = res.result.data.status;
      } else {
        alert('Error: ' + res.message);
        setTimeout(() => {
          selectEl.value = originalStatus;
        });
      }
    });
  }

  /**
   * Export Sample data in CSV
   */

  public uploadBulkUserSampleCsv() {
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

    let url = this.locator.config.get('endpoint.login') + '/bulkUserSampleCsv';
    if (url) {
      url += ';jsessionid=' + sid;
    }

    this.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe({
        next: (data: Blob) => {
          this.downloadDataAsFile(data, 'User_Sample.csv');
        },
        error: (err: any) => {
          console.error('CSV Download Failed:', err);
        },
      });
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }

  public errorList: { rowNumber: number; message: string }[] = [];
  public showErrorModal: boolean = false;

  public onCsvFileUpload() {
    const fileObj = this.selectedCsvFile;
    const _self = this;
    _self.form.error = false;
    _self.form.message = '';

    const name = this.applicationRoles.find(
      (item: any) => item.id === +_self.form.data['applicationRoleId'],
    );
    const data = {
      applicationRoleId: _self.form.data['applicationRoleId'],
      applicationId: _self.appId,
      role: name ? name['name'] : 'Guest',
    };

    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

    let url = this.locator.config.get('endpoint.login') + '/bulkUserSignup';
    if (url) {
      url += ';jsessionid=' + sid;
    }

    this.locator.http.postMutipart(
      url,
      data,
      fileObj,
      (res: any, error: any) => {
        if (error) {
          alert(error);
          return;
        }

        _self.form.error = !res.success;

        if (res.success) {
          _self.form.message = 'File uploaded successfully';
          _self.search();

          const errorSummary = res.result.errorSummary || {};
          _self.errorList = []; // Reset error list

          for (const rowNumber in errorSummary) {
            if (errorSummary.hasOwnProperty(rowNumber)) {
              _self.errorList.push({
                rowNumber: +rowNumber,
                message: errorSummary[rowNumber],
              });
            }
          }

          if (_self.errorList.length > 0) {
            const modal: any = new (window as any).bootstrap.Modal(
              document.getElementById('errorModal'),
            );
            modal.show();
          } else {
            alert('No Errors. All users uploaded successfully.');
          }
        } else {
          alert(res.message);
        }
      },
    );
  }

  // Declare file variable
  selectedCsvFile: File | null = null;

  // Handle file selection
  confirmUpload(event: any): void {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.csv')) {
      this.selectedCsvFile = file;
      console.log('File selected:', file.name);
    } else {
      this.selectedCsvFile = null;
      console.warn('Invalid file type');
    }
  }

  override resetForm() {
    this.form.data = {};
    const inputs = document.querySelectorAll('input[type="file"]');
    inputs.forEach((input: any) => (input.value = ''));
  }

  searchText: string = '';
  selectedRoleId: string = '';
  selectedStatus: string = '';
  roleList: string[] = ['Accept', 'Reject', 'Pending', 'Cancel'];

  searchUsers() {
    this.form.searchParams = {
      applicationId: Number(this.appId),
    };

    if (this.searchText && this.searchText.trim() !== '') {
      this.form.searchParams['email'] = this.searchText.trim();
    }

    if (this.selectedRoleId && this.selectedRoleId !== '') {
      this.form.searchParams['applicationRoleId'] = Number(this.selectedRoleId);
    }

    if (this.selectedStatus && this.selectedStatus !== '') {
      this.form.searchParams['status'] = this.selectedStatus;
    }

    super.search((error: any) => {
      if (this.form.searchMessage === 'Record not found') {
        this.form.list = [];
      } else if (this.form.list && this.form.list.length > 0) {
        const firstItem = this.form.list[0];
        if (firstItem && firstItem['applicationName']) {
          this.applicationName = firstItem['applicationName'];
        }
      }
    });
  }

  resetFilters() {
    this.searchText = '';
    this.selectedRoleId = '';
    this.selectedStatus = '';
    this.form.data['applicationRoleId'] = '';
    this.searchUsers();
  }

  resetselectemails() {
    this.emailList = [];
    this.emailInput = '';
    this.clearEmailError();
  }

  CurrentRoleData() {
    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const applicationRoleId = localStorage.getItem(keySuffix + 'roleId');

    if (!applicationRoleId) {
      console.log('No roleId found in localStorage');
    }

    const url =
      this.locator.config.get('endpoint.application.role') +
      '/get/' +
      applicationRoleId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        console.error('Server Error:', error);
      }

      let data = res.result?.data || null;
      this.currentRoleData = data;
      this.permission = this.hasPermissionData('App Users');
    });
  }

  hasPermissionData(permission: string) {
    const defaultPermission = {
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    };

    return (
      this.currentRoleData?.accessPermissions?.[permission] || defaultPermission
    );
  }
  canCreate() {
    return this.permission?.create === 1;
  }

  canRead() {
    return this.permission?.read === 1;
  }

  canUpdate() {
    return this.permission?.update === 1;
  }

  canDelete() {
    return this.permission?.delete === 1;
  }
}
